import { get } from '$lib/data/index.js';
import { DrupalJsonApiParams } from 'drupal-jsonapi-params';

const params = new DrupalJsonApiParams()
	.addSort('created', 'DESC')
	.addInclude(['field_poster', 'field_poster.field_media_image']);

const RESOURCE = `article?${params.getQueryString()}&jsonapi_include=1`;

const directorMessage = async () => {
	const res = await get(RESOURCE);
	const data = res.data;
	return data;
};

export default directorMessage;
